var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-alert',{attrs:{"message":"Information","description":"Our Dashboard is Coming Soon","type":"info","showIcon":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }